import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Collapse from "@mui/material/Collapse";
import { useMediaQuery } from "@mui/material";
import { useEffect } from "react";

const AnswerContainer = styled("div")({
  padding: "4px 20px",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "#f5f5f5",
  },
});

// prop example - const options = [{ label: "Select", values: ["Red", "Blue", "Green"] }]
const CustomSelectAccordion = ({
  value = null,
  options = [],
  onSelect = () => {},
  checkBox = false,
  backgroundColor,
  whiteSpace = "unset",
}) => {
  const [expanded, setExpanded] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const [multiSelectedValue, setMultiSelectedValue] = useState([]);

  const handleExpand = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleMultiSelect = (value) => {
    setMultiSelectedValue((prev) => {
      let newValues;
      if (prev?.includes(value)) {
        newValues = [...prev?.filter((item) => item !== value)];
      } else {
        newValues = [...prev, value];
      }
      onSelect(newValues);
      return newValues;
    });
  };

  const handleSelect = (value) => {
    setSelectedValue(value);
    setExpanded(false);
    onSelect(value);
  };
  const matches = useMediaQuery("(min-width: 600px)");

  useEffect(() => {
    if (checkBox) setMultiSelectedValue(value);
    else setSelectedValue(value);
  }, [value, checkBox]);

  return (
    <div style={{ width: "100%" }}>
      {options?.map((option, index) => (
        <Accordion
          key={index}
          expanded={expanded === `panel${index}`}
          onChange={handleExpand(`panel${index}`)}
          variant="outlined"
          sx={{
            backgroundColor: backgroundColor ? "#EBEEF8" : "FFFFFF",
            "& .MuiAccordionSummary-root": {
              minHeight: "38px",
              width: "fit-content",
            },
            "& .MuiAccordionSummary-root.Mui-expanded": {
              minHeight: "38px",
              width: "fit-content",
            },
          }}
        >
          <AccordionSummary
            sx={
              matches
                ? {
                    "& .MuiAccordionSummary-content": {
                      margin: "0px",
                    },
                    "& .MuiAccordionSummary-content.Mui-expanded": {
                      margin: "4px",
                    },
                    "& .MuiSvgIcon-root": { fontSize: "2.5rem" },
                  }
                : {
                    "& .MuiAccordionSummary-content": {
                      margin: "0px",
                    },
                    "& .MuiAccordionSummary-content.Mui-expanded": {
                      margin: "4px",
                    },
                    "& .MuiSvgIcon-root": { fontSize: "3.5rem" },
                  }
            }
            expandIcon={<ExpandMoreIcon />}
          >
            <Typography sx={{ fontSize: "14px", whiteSpace }}>
              {selectedValue ? selectedValue : option.label}
            </Typography>
          </AccordionSummary>

          <Collapse
            sx={{ margin: "1px" }}
            in={expanded === `panel${index}`}
            timeout="auto"
            unmountOnExit
          >
            {option?.values?.map((value, i) => (
              <AnswerContainer
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "2rem",
                }}
                key={i}
                onClick={() =>
                  checkBox ? handleMultiSelect(value) : handleSelect(value)
                }
              >
                <Typography sx={{ fontSize: "14px", whiteSpace }}>
                  {value}
                </Typography>
                {checkBox && (
                  <input
                    type="checkbox"
                    style={{ accentColor: "#E94D51", cursor: "pointer" }}
                    checked={multiSelectedValue?.includes(value)}
                  />
                )}
              </AnswerContainer>
            ))}
          </Collapse>
        </Accordion>
      ))}
    </div>
  );
};

export default CustomSelectAccordion;
